import crudApi from "../../../api/crudApi";
import listHandler from "../../../Domain/listHandler";
import GroupConfig from "../Resources/Endpoints";

const LeaveGroup = async (groupId) => {
  const response = await crudApi.del(GroupConfig.endpoints.leave, groupId);
  if (response.ok) {
    window.location.href = "/";
  }
};

const RemoveMember = async (
  dataList,
  setDataList,
  userGroupId,
  groupId,
  index
) => {
  const deleteUrl = GroupConfig.endpoints.removemember + groupId + "/";
  listHandler.deleteFromList(
    index,
    crudApi.del(deleteUrl, +userGroupId?.id),
    setDataList,
    dataList
  );
};

export { LeaveGroup, RemoveMember };
